import styles from './ProgressRing.module.css'

interface ProgressRingProps {
  value: number
  target: number
  label: string
  caption?: string
  size?: number
}

/**
 * The daily goal ring. Progress is shown as a number the user can name — "3 из
 * 5" — never as a bare percentage, because the goal is a count of words and the
 * ring should say the same thing the goal does.
 */
export function ProgressRing({ value, target, label, caption, size = 148 }: ProgressRingProps) {
  const stroke = 12
  const radius = (size - stroke) / 2
  const circumference = 2 * Math.PI * radius
  const ratio = target > 0 ? Math.min(value / target, 1) : 0

  return (
    <div className={styles.wrap} style={{ width: size, height: size }}>
      <svg width={size} height={size} aria-hidden="true">
        <circle
          className={styles.track}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={stroke}
          fill="none"
        />
        <circle
          className={styles.value}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={stroke}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - ratio)}
          /* Start at 12 o'clock instead of 3. */
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>

      <div className={styles.center}>
        <span className={styles.label}>{label}</span>
        {caption ? <span className={styles.caption}>{caption}</span> : null}
      </div>
    </div>
  )
}
